import React from "react";
import { Suspense, useEffect, useState, useRef } from "react";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import Loader from "../Layout/Loader";
import { authRoutes } from "./AuthRoutes";
import LayoutRoutes from "../Route/LayoutRoutes";
import Signin from "../Auth/Signin";
import PrivateRoute from "./PrivateRoute";
import { classes } from "../Data/Layouts";
import axios from 'axios';
import { handleSessionExpired } from '../Components/V3/hooks/sessionExpired';
import { refreshAccessToken, isAuthorizationDenied } from '../Components/V3/hooks/tokenRefresh';


// setup fake backend


const Routers = () => {
  const login = useState(JSON.parse(localStorage.getItem("login")))[0];
  const userType = localStorage.getItem("usertype");
  const [authenticated, setAuthenticated] = useState(false);
  const defaultLayoutObj = classes.find((item) => Object.values(item).pop(1) === "compact-wrapper");
  const layout = localStorage.getItem("layout") || Object.keys(defaultLayoutObj).pop();
  const [sessionExpired, setSessionExpired] = useState(false);
  const sessionExpiredRef = useRef(false);

  useEffect(() => {
    let abortController = new AbortController();
    setAuthenticated(JSON.parse(localStorage.getItem("authenticated")));
    console.ignoredYellowBox = ["Warning: Each", "Warning: Failed"];
    console.disableYellowBox = true;
    return () => {
      abortController.abort();
    };
  }, []);

  useEffect(() => {
    const interceptor = axios.interceptors.response.use(
      response => response,
      async error => {
        const original = error.config || {};
        const status = error.response && error.response.status;

        // rbac "Missing permission" 403 — the user is authenticated but not
        // allowed this one resource. Deny the action; never end the session.
        if (isAuthorizationDenied(error)) {
          return Promise.reject(error);
        }

        // Auth failure (expired/invalid/missing token) — try a single silent
        // refresh, then retry the original request. Only if refresh is
        // impossible do we treat the session as expired.
        const isAuthErr = status === 401 || status === 403;
        if (isAuthErr && !original._retry) {
          original._retry = true;
          const newToken = await refreshAccessToken();
          if (newToken) {
            original.headers = original.headers || {};
            original.headers.Authorization = newToken;
            return axios(original);
          }
          if (!sessionExpiredRef.current) {
            sessionExpiredRef.current = true;
            setSessionExpired(true);
            handleSessionExpired();
          }
        }
        return Promise.reject(error);
      }
    );

    // Cleanup interceptor on unmount
    return () => {
      axios.interceptors.response.eject(interceptor);
    };
  }, [sessionExpired]);



  return (
    <BrowserRouter basename={"/"}>
      <Suspense fallback={<Loader />}>
        <Routes>
          <Route path={"/"} element={<PrivateRoute />}>
            {login || authenticated ? (
              <>
                {userType === "admin" && (
                  <>
                    <Route exact path={`${process.env.PUBLIC_URL}`} element={<Navigate to={`${process.env.PUBLIC_URL}/v3/spatial`} />} />
                    <Route exact path={`/`} element={<Navigate to={`${process.env.PUBLIC_URL}/v3/spatial`} />} />
                  </>
                )}
                {userType === "sadmin" && (
                  <>
                    <Route exact path={`${process.env.PUBLIC_URL}`} element={<Navigate to={`${process.env.PUBLIC_URL}/controlpanel/dashboard/default/${layout}`} />} />
                    <Route exact path={`/`} element={<Navigate to={`${process.env.PUBLIC_URL}/controlpanel/dashboard/default/${layout}`} />} />
                  </>
                )}
                {userType === "tenant" && (
                  <>
                    <Route exact path={`${process.env.PUBLIC_URL}`} element={<Navigate to={`${process.env.PUBLIC_URL}/dashboard/default/${layout}`} />} />
                    <Route exact path={`/`} element={<Navigate to={`${process.env.PUBLIC_URL}/tenant/home/${layout}`} />} />
                  </>
                )}
                {userType === "Backend User" && (
                  <>
                    <Route exact path={`${process.env.PUBLIC_URL}`} element={<Navigate to={`${process.env.PUBLIC_URL}/dashboard/default/${layout}`} />} />
                    <Route exact path={`/`} element={<Navigate to={`${process.env.PUBLIC_URL}/admin/home/${layout}`} />} />
                  </>
                )}
                {userType !== "admin" && userType !== "sadmin" && userType !== "tenant" && userType !== "Backend User" && (
                  <>
                    <Route exact path={`${process.env.PUBLIC_URL}`} element={<Navigate to={`${process.env.PUBLIC_URL}/v3/spatial`} />} />
                    <Route exact path={`/`} element={<Navigate to={`${process.env.PUBLIC_URL}/v3/spatial`} />} />
                  </>
                )}
              </>
            ) : (
              ""
            )}
            <Route path={`/*`} element={<LayoutRoutes />} />
          </Route>

          <Route exact path={`${process.env.PUBLIC_URL}/login`} element={<Signin />} />
          {authRoutes.map(({ path, Component }, i) => (
            <Route path={path} element={Component} key={i} />
          ))}
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
};

export default Routers;
